import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import PageTitle from "./PageTitleCompoent";
import "../css/OrderDetailsScreen.css";
import { motion } from "framer-motion";

export default function RecentOrderDetailsScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const { order } = location.state || {};

  const handleBack = () => {
    navigate(-1);
  };

  if (!order) {
    return (
      <div className="order-details-container">
        <Sidebar />
        <div className="order-details-main">
          <Header />
          <div className="order-details-content">
            <PageTitle
              title="Order Details"
              subtitle="Detailed information about an Order"
              onBack={handleBack}
              showBackArrow={true}
            />
            <p>No order data found.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="order-details-container">
      <Sidebar />
      <div className="order-details-main">
        <Header />
        <motion.div
          className="order-details-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <PageTitle
            title="Order Details"
            subtitle="Detailed information about the order"
            onBack={handleBack}
            showBackArrow={true}
          />

          <motion.div
            className="order-details-card"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            {/* Order Header Section */}
            <div className="order-details-header">
              {/* Left side: Product Image */}
              <div className="product-info">
                <img
                  src={order.imageUrl}
                  alt={order.name}
                  className="product-image"
                />
              </div>

              {/* Right side: Details */}
              <div className="details-container">
                <div className="product-details">
                  <span className="product-name">{order.name}</span>
                  <span className="product-weight">{order.weight}</span>
                </div>

                <div className="price-container">
                  <span className="price">Rs {order.price}</span>
                  {order.originalPrice && (
                    <span className="original-price">
                      Rs {order.originalPrice}
                    </span>
                  )}
                </div>

                <div className="order-date">
                  <span>{order.date}</span>
                </div>

                <div className="status-container">
                  <span className="label">Status:</span>
                  <span
                    className={`order-status-badge ${order.status.toLowerCase()}`}
                  >
                    {order.status}
                  </span>
                </div>

                <div className="payment-info">
                  <span className="label">Payment:</span>
                  <span>{order.payment}</span>
                </div>

                <div className="payment-type-info">
                  <span className="label">Payment Type:</span>
                  <span>{order.paymentType}</span>
                </div>
              </div>
            </div>

            {/* Description Section */}
            <div className="description-section">
              <h3 className="description-title">{order.name}</h3>
              <p className="description-text">{order.description}</p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}
